import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CinematicScene } from '../CinematicScene';
import { Reveal } from '../Reveal';
import { ActionButton } from '../ActionButton';
import { brand, imagery } from '../../data/site';
import { MotionMode } from '../../types/motion';
interface HeroSceneProps {
  motionMode?: MotionMode;
}
export function HeroScene({
  motionMode = 'cinematic'
}: HeroSceneProps) {
  const reduced = useReducedMotion();
  return <CinematicScene id="ritual" image={imagery.hero} imageAlt="Espresso resting on a walnut counter inside the dark, brass-lit kitchen at dawn" motionMode={motionMode} scrim="center" height="tall" data-id="element-51" data-mp="338r29tjhli5q">
      <div className="mx-auto flex h-full max-w-4xl flex-col items-center justify-center px-6 text-center md:px-10" data-id="element-52" data-mp="2y6jnyxb6pq08">
        <Reveal delay={0.15} data-id="element-53" data-mp="sfo8a5b40nf2">
          <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.3em] text-brass md:text-[11px]" data-id="element-54" data-mp="sc8vj94wrqgt">
            {brand.eyebrow}
          </p>
        </Reveal>

        <Reveal delay={0.35} data-id="element-55" data-mp="1d178npau7q75">
          <h1 className="font-display text-[2.6rem] font-normal leading-[1.1] tracking-tight text-cream sm:text-6xl lg:text-[5.25rem]" data-id="element-56" data-mp="1d0fbwb5i7mfa">
            ELEVATING THE ART
            <br data-id="element-57" data-mp="1mr0ahyl6gqy7" />
            OF THE DAILY RITUAL.
          </h1>
        </Reveal>

        <Reveal delay={0.55} data-id="element-58" data-mp="1hsytdj7bb1pd">
          <p className="mx-auto mt-7 max-w-md font-mono text-[12.5px] leading-[1.8] text-stone md:text-[13.5px]" data-id="element-59" data-mp="1hu0ekgi1l4kt">
            Where high-end culinary craft meets the soul of hand-roasted coffee.
          </p>
        </Reveal>

        <Reveal delay={0.75} data-id="element-60" data-mp="p6xj5x8nx9ys">
          <div className="mt-11 flex flex-col items-center gap-4 sm:flex-row sm:gap-5" data-id="element-61" data-mp="142d7rmqh4dns">
            <ActionButton href="#visit" data-id="element-62" data-mp="z30m35bc9cms">Reserve Your Table</ActionButton>
            <ActionButton href="#kitchen" variant="ghost" data-id="element-63" data-mp="z53jwbiqga22">
              Explore the Kitchen
            </ActionButton>
          </div>
        </Reveal>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2" data-id="element-64" data-mp="2ah4c60et2gmk">
        <motion.div className="flex flex-col items-center gap-3" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.6,
        duration: 1.2
      }} data-id="element-65" data-mp="2hlm12wqsoipq">
          <span className="font-mono text-[9px] uppercase tracking-[0.3em] text-stone" data-id="element-66" data-mp="2rj0baem4kb9l">
            Scroll
          </span>
          <div className="relative h-12 w-px overflow-hidden bg-cream/15" data-id="element-67" data-mp="2whuv9jvtw5va">
            {!reduced && <motion.span className="absolute inset-x-0 top-0 h-5 bg-brass" animate={{
            y: ['-100%', '240%']
          }} transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-68" data-mp="1yw5tjpgozpzt" />}
          </div>
        </motion.div>
      </div>
    </CinematicScene>;
}